/* eslint-disable react/require-default-props */

import BpkModal from '@skyscanner-internal/backpack-web/bpk-component-modal';
import { GLOBAL } from 'saddlebag-browser';

import SlideshowView from './SlideshowView';

import type { ImageEntry } from '../types';

import STYLES from './SlideshowViewModal.module.scss';

const $document = GLOBAL.getDocument();

type Props = {
  aspectRatio?: string;
  onClose: () => void;
  images: ImageEntry[];
  initialImageIndex: number;
  translations: {
    viewPhotosButton: string;
    closeModal: string;
    previousImage: string;
    nextImage: string;
  };
};

const SlideshowViewModal = (props: Props) => (
  <BpkModal
    closeOnEscPressed
    fullScreen
    getApplicationElement={() => $document.getElementById('pagewrap')}
    id="ce-image-gallery"
    isOpen
    onClose={props.onClose}
    padded={false}
    renderTarget={() => $document.getElementById('modal-container')}
    showHeader={false}
    className={STYLES.dialog}
    ariaLabel={props.translations.viewPhotosButton}
  >
    {/* It's separated to make sure the content is indeed mounted for scroll to initial image in the useEffect */}
    <SlideshowView {...props} />
  </BpkModal>
);

export default SlideshowViewModal;
